import responsiveVars from '@/styles/responsive.module.scss';
import { DEFAULT_MODAL_WIDTH } from '@/utils/modal-utils.js';

const _width = window.innerWidth || window.screen.width;

// Fallback: ensure values exist even if CSS named exports are not supported by loader
const { tablet, desktop } = responsiveVars || {};

const _tablet = Number.parseInt(tablet); // default 482px
const _desktop = Number.parseInt(desktop); // default 1025px
const UA = navigator.userAgent;

// RegEx are from the BillingMobileUtil.java, should keep consistent with it
const _mobileUA = /mobile|android|iphone|phone/i;
const _tabletUA = /ipad/i;

export const isMobile = _mobileUA.test(UA) || (_width < _tablet);
export const isTablet = _tabletUA.test(UA) || (_width >= _tablet && _width < _desktop);
export const isDesktop = _width >= _desktop;

export const isMobileInClient = DEFAULT_MODAL_WIDTH < _tablet;
export const isTabletInClient = DEFAULT_MODAL_WIDTH >= _tablet && DEFAULT_MODAL_WIDTH < _desktop;
export const isDesktopInClient = DEFAULT_MODAL_WIDTH >= _desktop;
